
import React, { useEffect, useState } from "react";
import { Products } from "./Products";
import axios from "axios";
import toast from "react-hot-toast";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelected } from "../store/reducers/CartReducer";
import PaintSVG from "./PaintSVG";
import TruncateText from "./TruncateText";

export const ProductPage = ({lang}) => {

  const [img,setImg] = useState(false)

 
  const [products,setProducts] = useState([])
  const [product,setProduct] = useState([])
  const [animation,setAnimation] = useState(true)

const param = useParams()

const id = param.id;

const dispatch = useDispatch()
useEffect(() => {
dispatch( setSelected({select:1}))
}, []);
useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
  //  console.log(window.innerWidth);
    return () => window.removeEventListener("resize", handleResize);
    
  
  }, []);

  const [width, setWidth] = useState(window.innerWidth);

  const location = useLocation();
  useEffect(() => {
    fetchProduct(id);
    var suggested = document.getElementById("suggested");
    suggested.scrollTo(0,0)
     }, [location]);
 
 


     const fetchProduct = async (id) => {

      setAnimation(true)
      
        try {
         axios.get(`https://demo.future-swift.com/Api/Product.php?product_id=${id}`)
         .then(res => {
           if(res.data.success === true){
       
           
             setProduct(res.data.product.productdata);
          
             setProducts(res.data.product.Suggestedproducts);

             setAnimation(false)
           }else{
             
       setProduct([])
       setProducts([]);
       setAnimation(false)
             toast.error(`${res.data.msg}`,{duration: 1000,},)
           
                
               }  
         
       
         })
       } catch (error) { 
       
       
       throw error;}      
       
       
            }
       

            const guarentee=[
              lang=== 'en' ? 'Years ' : 'سنين ',
              lang=== 'en' ? 'Months ' : 'شهور ',
              lang=== 'en' ? 'Days ' : 'ايام ',
            ]
          
            
            const guarentee_=[
              lang=== 'en' ? 'Year ' : 'سنة ',
              lang=== 'en' ? 'Month ' : 'شهر ',
              lang=== 'en' ? 'Day ' : 'يوم ',
            ]
          

  return (
    <section  className=" pt-[80px] px-[3%] text-right bg-white min-h-screen w-full">
 { //loading...
  animation? 
  
<div className={`${width > 700 ? 'flex' : 'flex-col'}  w-full mt-[30px]`}>


<div className={`${width > 700 ? 'w-[50%] ' : 'w-[100%]'}  flex-col  `}>

<div className="animate-pulse">
<div style={{aspectRatio:1,maxHeight:'70%'}} className="  m-auto w-[90%] rounded bg-[#f4f4f4]  " />
  
</div>
   




<div  style={{overflowX:'hidden'}} className="m-auto max-w-[90%] flex gap-2  pt-[20px]">
{[...Array(10)].map((_, index) => (


<div
                key={index}
                style={{fontFamily:'cairoLight'}}
              
                className={`flex m-auto px-1 py-1  rounded-xl min-w-[120px]
                
                   bg-zinc-100   
                 h-[35px]  animate-pulse`}
              >
              <div  className="my-1 m-auto w-[80%]   mt-2 h-2 rounded bg-gray-200 " />
              </div>
          


))}
</div>  

</div>




<div className={`${width > 700 ? 'w-[50%] ' : 'w-[100%] mt-4'}  flex-col `}>

<div  className={`m-auto flex w-[90%] px-1 h-[100px] bg-[#f4f4f4] mb-2 rounded animate-pulse`}>
<div className="w-[60%] h-[100px] flex flex-col " >
<div className=" m-auto flex flex-col w-full">
<div  className=" w-[60%] m-auto h-2 rounded bg-gray-200" />
<div  className=" w-[90%] m-auto  mt-1 h-2 rounded bg-gray-200 " />
</div>
</div>

<div className="w-[40%] m-auto">


<div
                 
 className="m-auto w-full rounded bg-gray-200 h-[95px] "
                />
</div>

</div>
<hr />
<div  className=" my-1 w-[60%] mt-2  h-2 rounded bg-gray-200" />
<div  className="my-1  w-[90%]   mt-2 h-2 rounded bg-gray-200 " />
<div  className="my-1  w-[90%]   mt-1 h-2 rounded bg-gray-200 " />
<div  className="my-1  w-[90%]   mt-1 h-2 rounded bg-gray-200 " />
<div  className="my-1  w-[80%]   mt-1 h-2 rounded bg-gray-200 " />
<br />

<div  className="my-1  w-[90%]   mt-2 h-2 rounded bg-gray-200 " />
<br />

<div  className="my-1  w-[90%]   mt-1 h-2 rounded bg-gray-200 " />
<br />

<div  className="my-1  w-[90%]   mt-1 h-2 rounded bg-gray-200 " />
<br />

<div  className="my-1  w-[90%]   mt-1 h-2 rounded bg-gray-200 " />
<hr />

</div>








</div>




:
  
  
  product.length > 0 ?     

<div className={`${width > 700 ? 'flex' : 'flex-col'}  w-full mt-[30px]`}>


<div className={`${width > 700 ? 'w-[50%] ' : 'w-[100%]'}  flex-col `}>
{Number(product[0].category) === 13  && !img ?

<div style={{aspectRatio:1,maxHeight:'70%'}} className="  m-auto w-[90%] rounded  ">
<PaintSVG  color={product[0].color} />
    </div>
     



        :
        
        <img
                 src={`https://demo.future-swift.com/products/${product[0].src}`}
                  alt={`${product[0].title} - ${product[0].title_en}`}
                  className="object-contain m-auto w-[90%] rounded  "
                style={{aspectRatio:1,maxHeight:'70%'}}

                />}
{
Number(product[0].guarantee) > 0 ?
<div className={` flex gap-2 min-w-[200px] ${width > 700 ? 'w-[20%]' : 'w-[40%]'} absolute m-auto p-1 bg-green-400/80 ${lang ==='en' ? 'rounded-r' : ' rounded-l '} h-[50px] mt-[-120px] `} >
<p style={{fontFamily:'CairoExtraBold'}} className= {`${lang ==='en' ? 'text-right' : 'text-left'}  w-[20%] text-[25px] m-auto text-[#ffffff] `}>
{  product[0].guarantee }  
</p>

<p style={{fontFamily:'CairoBold'}} className={`w-[80%] ${lang ==='en' ? 'text-left' : 'text-right'}  m-auto text-[#ffffff]`}>
{Number(product[0].guarantee) > 1 ? guarentee[product[0].guarantee_type] : guarentee_[product[0].guarantee_type] }
{  lang=== 'en' ? 'Guarantee ' : 'ضمانة '} 
</p>
</div>

:''
}


{Number(product[0].category) === 13 ?
<div  className="m-auto p-1 mt-[-58px] w-[90%]">


<button onClick={()=>setImg(!img)} className="" >


{!img  ?


  <img
                 src={`https://demo.future-swift.com/products/${product[0].src}`}
                  alt={`${product[0].title} - ${product[0].title_en}`}
                  className=" w-[50px] h-[50px] rounded bg-[#9C9C9C] "
             

                />

        :
        
<div  className="  w-[50px] h-[50px] rounded bg-[#9C9C9C]/30 ">
<PaintSVG  color={product[0].color} />
    </div>
     
       }
</button>
 </div>
 :''}


<div  style={{overflowX:'auto'}} className="m-auto max-w-[90%] flex gap-2  pt-[20px]">
{product[0].tags.map((item, index) => (


<button
                key={index}
                style={{fontFamily:'cairoLight'}}
                onClick={()=>{

             
           }}
                className={` m-auto px-1 py-1  rounded-xl min-w-[120px]
                
                   bg-zinc-100   
                 h-[35px] `}
              >
               #{lang === 'en' ? item.value_en :item.value}
              </button>
          


))}
</div>  
{Number(product[0].category) === 13 || Number(product[0].category) === 14 ?

<div className=" flex m-auto my-3 w-[90%]">


<Link to={`/Test/${product[0].category}/${Number(product[0].category) === 13? product[0].color.replace(/#/g, '') :product[0].src}`}
className="mx-auto rounded w-full p-2 border-[1px] border-primary text-center text-primary hover:opacity-[0.7] " >

{lang === 'en' ? 'Test Now !' : 'جربة الان !'}
  
</Link>
</div>


:''

}

</div>




<div className={`${width > 700 ? 'w-[50%] ' : 'w-[100%] mt-4'}  flex-col `}>

<Link to={`/brand/${product[0].brand}`}  className={`m-auto flex w-[90%] px-1 h-[100px] bg-[#f4f4f4] mb-2 rounded`}>
<div className="w-[60%] h-[100px] flex flex-col " >
<div className=" m-auto ">
<h3 style={{fontFamily:'CairoBold'}} className=" w-full text-center"> Product's Brand </h3>
<h4  className=" w-full text-center "> {  lang ==='en' ? 'View more from this company' : 'عرض المزيد من هذة الشركة'}</h4>
</div>
</div>

<div className="w-[40%] m-auto">


<img
                  src={`https://demo.future-swift.com/img/${product[0].brand_src}`}
                  alt={`${product[0].brand_title_en} - ${product[0].brand_title}`}
                       className="object-contain m-auto w-full max-h-[95px] "
                />
</div>

</Link>
<hr />
<h2 style={{fontFamily:'CairoExtraBold'}} className={`${lang === 'en' ? 'text-left' :'text-right'} m-auto w-[90%] my-2`}> {  lang ==='en' ? product[0].title_en : product[0].title}</h2>

<p style={{whiteSpace:'pre-wrap'}} className={`${lang === 'en' ? 'text-left' :'text-right'} m-auto w-[90%] mb-2`}>
    {  lang ==='en' ? product[0].description_en : product[0].description}

</p>


</div>








</div>

:


''

}


<div className={` mt-10 w-full `} >
   {/* Custom <hr/> */}
   <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
<h2 style={{fontFamily:'CairoExtraBold'}} className= {`text-[#333333] ${lang === 'en' ? "text-left" : "text-right"} text-[20px]  xl:text-[50px]  lg:text-[40px] md:text-[30px]   sm:text-[25px]  xs:text-[20px] `} >
      {lang === 'en' ? "Suggested Products" : "منتجات مقترحة"} 
          </h2>

          <div className={`translate-y-[150px]  ${animation ? `transition-all delay-500 duration-200  opacity-[1]` :  'transition-all  duration-200 opacity-[0]'  }   w-full flex`}>
       <div className="m-auto animate-spin">

       <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-red-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
 </div>
              </div>
          <div id="suggested" style={{overflowX:'auto'}} className= {`min-h-[300px]   ${animation ? `transition-all  duration-500 ${lang === 'en' ? '-translate-x-[100%]' :'translate-x-[100%]'} opacity-[0]` :  'transition-all  duration-500 translate-x-[0] opacity-[1]'  }  w-full  p-1 flex gap-2 `}>
            {products.map((item, index) => (
              <Link
              
              to={`/Product/${item.id}`}
             // onClick={()=>{fetchProduct(item.id)}}
                key={index}
                className="group hover:bg-white hover:shadow-lg p-1 relative mx-auto flex flex-col rounded-[7px]  bg-[#F4F4F4] h-[200px] w-[150px] min-h-[200px] min-w-[150px]  
                lg:w-[250px] lg:h-[350px] xl:w-[300px] xl:h-[450px] md:h-[250px] md:w-[200px]
                lg:min-w-[250px] lg:min-h-[320px] xl:min-w-[300px] xl:min-h-[370px] md:min-h-[250px] md:min-w-[200px] "
              >
               {Number(item.category) === 13 ?

       <div className="  w-[140px] h-[140px] lg:w-[240px] lg:h-[240px] xl:w-[290px] xl:h-[290px]  md:h-[190px] md:w-[190px]">
       <PaintSVG  color={item.color} />
           </div>
            



               :
                <img
                 src={`https://demo.future-swift.com/products/${item.src}`}
                  alt={`Product ${index + 1}`}
                  className="object-contain m-auto w-[140px] max-h-[140px] lg:w-[240px] lg:max-h-[240px] xl:w-[290px] xl:max-h-[290px]  md:h-[190px] md:w-[190px]"
                />}
           
              <div className="flex max-w-full  h-[3px] w-full" />
              <div className="m-auto  w-[140px]  h-[50px]  lg:w-[240px] lg:h-[70px] xl:w-[290px] xl:h-[70px] md:h-[50px] md:w-[190px]">
               
               <h3 style={{fontFamily:'CairoSemiBold'}} className={`${lang === 'en' ? "text-left" : "text-right"} w-full text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] xl:text-[18px]`}> {lang === 'en' ? item.title_en : item.title }</h3>
               <div className="group-hover:block    hidden  flex my-[1px] max-w-full bg-zinc-300 h-[2px] w-full" />
               <p style={{fontFamily:'CairoMedium'}} className={` ${lang === 'en' ? "text-left" : "text-right"} text-[9px] sm:text-[10px] md:text-[12px] lg:text-[14px] xl:text-[16px]`}>{lang === 'en' ? TruncateText( item.description_en, 50)  :TruncateText( item.description, 60)}</p>
              </div>


              </Link>
            ))}
          </div>

          
      

        </div>

    </section>
  );
};
